export default "__VITE_ASSET__928fa6b5__$_?react__"